<template>
  <div class="form-container sign-up-container" id="auth-modal-content">
    <loading class="register-overlay" v-show="showLoader"/>

    <form @submit.prevent="handleLoginSubmit">
      <div class="jbl-sign-right in-lg-devices">
        <img alt="Logo Icon" class="img-fluid" :src="require('@/assets/images/ib-logo.svg')" />
        <h1 class="login-title">Sign In</h1>
        <h5 class="ib-login-text">Please Sign in to Continue</h5>
        <div>
          <div class="ib-input-field">
            <label class="jbl-label-sign">Username<span>*</span></label>
            <input type="text" class="ib-login-input" name="username" v-model="user.username" placeholder="Enter Username">
          </div>

          <div v-if="errors.filter(x => x.field == 'username').length > 0">
            <div class="d-block jbl-text-danger">
              <small class="text-danger">{{errors.filter(x => x.field == 'username')[0].message}}</small>
            </div>
          </div>
        </div>
        <div>
          <div class="ib-input-field">
            <label class="jbl-label-sign">Password<span>*</span></label>
            <input type="password" id="signin_passsword" class="ib-login-input" name="password" v-model="user.password" placeholder="Enter Password" autocomplete="off">
            <span id="signin_eye" class="fa fa-fw fa-eye field-icon toggle-password in-eye-btn" @click="toogleView()"></span>
          </div>

          <div v-if="errors.filter(x => x.field == 'password').length > 0">
            <div class="d-block jbl-text-danger">
              <small class="text-danger">{{errors.filter(x => x.field == 'password')[0].message}}</small>
            </div>
          </div>
        </div>
        <div class="container px-0 mb-3">
          <div class="row jbl-forgot-pass">
            <div class="col-6 text-left">
              <div class="invisible">
                <label class="ib-checkbox-container ib-required-label remember-forgot-text" style="text-align:left !important;">
                  Remember Me
                  <input value="true" type="checkbox">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="col-6 text-right pr-1">
              <router-link :to="{ name: 'ForgotPassword' }" class="remember-forgot-text float-right">Forgot Password<span class="Qmark" style="font-size:inherit;">?</span></router-link>
            </div>
          </div>
        </div>
        <button type="submit" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4">Sign In</button>
      </div>
      <div>
        <h6>Not a User<span>?</span> Please <span class="ib-cursor-pointer" style="color:#ef7c94;" @click="closeSignInOpenSignUpModal()">Sign Up</span></h6>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import loading from '@/components/Loading/Loading'

  export default {
    name: "SignIn",
    components: {
      loading
    },
    data () {
      return {
        user: {
          username: "",
          password: "",
        },
        errors: [],
        showLoader : false,
      };
    },
    methods: {
      ...mapActions(["LogIn"]),
      async handleLoginSubmit(e) {
        const self = this;
        self.showLoader = true;
        self.errors = [];

        Object.entries(self.user).forEach(([key, value]) => {
          if (value == '') {
            self.errors.push({
              field: key,
              message: key.replace(/_/g,' ') + ' required'
            });
          }
        });

        if (self.errors.length > 0) {
          self.showLoader = false;
          return false;
        }

        await self.LogIn(self.user).then((response) => {
          self.showLoader = false;
          self.$root.$emit('updateUser');
          if (response.data.data.user.otp_verified === 0) {
            this.$router.push('otpverification');
          } else if(response.data.data.user.email_verified_at == null) {
            this.$router.push('verifyemail');
          } else if (response.data.data.user.username_verified === 0) {
            this.$router.push('username');
          } else {
            if(response.data.data.user.chance_become_founder_member && response.data.data.user.is_founder_member == 0) {
              self.$store.commit('setSignupRedirect');
            }
            window.location.reload();
          }
        }).catch(error => {
          self.showLoader = false;
          $toast.error(error.data.message, { position: 'top-right' });
        });
      },
      closeSignInOpenSignUpModal() {
        const self = this;
        self.$root.$emit('closeSignInOpenSignUpModal');
      },
      toogleView() {
        var input = document.getElementById('signin_passsword');
        var eye = document.getElementById('signin_eye');

        if (input.getAttribute("type") == "password") {
          input.setAttribute("type", "text");
          eye.classList.remove('fa-eye');
          eye.classList.add('fa-eye-slash');
        } else {
          input.setAttribute("type", "password");
          eye.classList.remove('fa-eye-slash');
          eye.classList.add('fa-eye');
        }
      }
    }
  };
</script>

<style scoped>
  @font-face {
    font-family: 'Futura PT Medium';
    src: url('~@/assets/fonts/futura-pt-medium.otf') format('otf');
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: 'Futura PT Demi';
    src: url('~@/assets/fonts/futura-pt-w01-demibold.ttf') format('ttf');
    font-weight: bold;
    font-style: normal;
  }
  .register-overlay {
    width: inherit !important;
  }
  form {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 50px;
    height: 100%;
    text-align: center;
  }
  /* .form-container {
    position: absolute;
    top: 0;
    height: 100%;
    right: 5%;
    transition: all 0.6s ease-in-out;
  } */
  .container.right-panel-active .sign-in-container {
    transform: translateX(100%);
  }
  @keyframes show {
    0%, 49.99% {
      opacity: 0;
      z-index: 1;
    }
    50%, 100% {
      opacity: 1;
      z-index: 5;
    }
  }
  input:focus ~ .floating-label,
  input:not(:focus):valid ~ .floating-label {
    top: 8px;
    bottom: 10px;
    left: 20px;
    font-size: 11px;
    opacity: 1;
  }
  @media(max-width:550px){
    .login-title {
      margin: 2rem 0rem 2rem !important;
    }
  }
  .jbl-sign-right{
    width: 130% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Auth/SignIn.vue